module.exports = __webpack_public_path__ + "img/debit-card.50afc091.png";